import { getRegexExpression } from '@/vendors/tiptap/helpers'

export default link => {
  return !![getRegexExpression('youtube'), getRegexExpression('vimeo'), getRegexExpression('dailymotion')].find(regex => link && link.match(regex))
}